import jQuery from 'jquery';
import Swiper from '../libs/swiper/swiper-bundle.min';

jQuery(function($) {
  const DEFAULT_OPTIONS = {
    speed: 400, spaceBetween: 100,

    // Optional parameters
    loop: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper__button--next', prevEl: '.swiper__button--prev',
    },

    // Generate events
    on: {
      slideChange: function() {
        $(this.$el).triggerHandler('slideChange', this.realIndex);
      },
    },
  };

  let customOptions = {};
  let options = {};

  /* Main */
  const swiperMain = new Swiper('.swiper--main', DEFAULT_OPTIONS);

  /* Projects */
  const swiperProjects = new Swiper('.swiper--projects', DEFAULT_OPTIONS);

  /* Review */
  customOptions = {
    slidesPerView: 1, spaceBetween: 10,

    breakpoints: {
      992: {
        slidesPerView: 2, spaceBetween: 28,
      },
    },
  };
  options = $.extend({}, DEFAULT_OPTIONS, customOptions);
  const swiperReviewTwo = new Swiper('.swiper--review__two', options);

  /* Review */
  customOptions = {
    slidesPerView: 1, spaceBetween: 10,

    breakpoints: {
      768: {
        slidesPerView: 2, spaceBetween: 20,
      },
      992: {
        slidesPerView: 3, spaceBetween: 28,
      },
    },
  };
  options = $.extend({}, DEFAULT_OPTIONS, customOptions);
  const swiperReviewThree = new Swiper('.swiper--review__three', options);

  /* Services */
  if (window.innerWidth < global.width_md) {
    const swiperServices = new Swiper('.swiper--services', DEFAULT_OPTIONS);
  }

  /* Portfolio */
  customOptions = {
    slidesPerView: 1, spaceBetween: 10,

    breakpoints: {
      576: {
        slidesPerView: 2, spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 28,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 28,
      },
    },
  };
  options = $.extend({}, DEFAULT_OPTIONS, customOptions);
  const swiperPortfolio = new Swiper('.swiper--portfolio', options);

  /* one slide */
  const swiperOneSlide = new Swiper('.swiper--one-slide', DEFAULT_OPTIONS);

  /* Product */
  const swiperProducr = new Swiper('.swiper--square', DEFAULT_OPTIONS);

  /* vertical video */
  const swiperVerticalVideo = new Swiper('.swiper--vertical-video', {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    loop: true,
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper__button--next',
      prevEl: '.swiper__button--prev',
    },
  });

  const $svModal = $('#swiper-video-modal');
  const $svVideo = $('.swiper-video-modal__video').get(0);
  const $svLink = $('.swiper-video-modal__inner');

  $svLink.on('click', function(event) {
    const src = $(this).data('src');

    $svVideo.src = src;

    $svModal.modal('show');
  });

  $svModal.on('show.bs.modal', function(e) {
    $svVideo.currentTime = 0;

    setTimeout(() => {
      $svVideo.play();
    }, 100);
  });

  $svModal.on('hide.bs.modal', function(e) {
    $svVideo.pause();
  });
});
